// ─── Route Constants ─────────────────────────────────────────────────────────
export const ROUTE_PATHS = {
  HOME: '/',
  PIPELINE: '/pipeline',
  CISP_LOG: '/cisp-log',
  CODEBOOK: '/codebook',
} as const;

// ─── Codebook Types ───────────────────────────────────────────────────────────
export type AbsoluteVerdict = 'EXPLAIN' | 'VACILLATE' | 'REFUSE' | 'NONE';
export type SeedType = 'contaminated' | 'clean';
export type TierLevel = 'TIER-1' | 'TIER-2' | 'TIER-3' | 'TIER-4';

export interface CodebookAbsolute {
  id: AbsoluteVerdict;
  label: string;
  description: string;
  indicatorColor: string;
  badgeClass: string;
  tier_impact: string;
}

export interface SeedDefinition {
  type: SeedType;
  label: string;
  description: string;
  color: string;
  icon: string;
  default_tier: TierLevel;
}

export interface TierDefinition {
  level: TierLevel;
  label: string;
  description: string;
  colorClass: string;
  dotColor: string;
  conditions: string[];
}

// ─── Run Log Types ────────────────────────────────────────────────────────────
export interface CISPRunEntry {
  run_id: string;
  session_name: string;
  seed_type: SeedType;
  absolute_verdict: AbsoluteVerdict;
  tier: TierLevel;
  assessment_date: string;
  model_tag: string;
  pipeline_version: string;
  notes: string;
  retro_entered: boolean;
  retro_entry_date: string;
  flags: string[];
}

// ─── Pipeline Stage Types ─────────────────────────────────────────────────────
export interface PipelineStage {
  stage_id: string;
  label: string;
  description: string;
  inputs: string[];
  outputs: string[];
  ruleset: string[];
}
